import React, { useEffect, useRef, useState } from "react";
import {
  EditorState,
  CompositeDecorator,
  RichUtils,
  ContentState,
  convertToRaw,
  convertFromHTML,
  Modifier,
  convertFromRaw,
} from "draft-js";
import Editor from "draft-js-plugins-editor";
import "draft-js-inline-toolbar-plugin/lib/plugin.css";
import createLinkifyPlugin from "@draft-js-plugins/linkify";
import { stateToHTML } from "draft-js-export-html";
import StaticToolbar, { toolbarPlugin } from "./StaticToolbarDescription";
import createInlineToolbarPlugin from "draft-js-inline-toolbar-plugin";
import createLinkPlugin from "draft-js-anchor-plugin";
import "../note_details/linkStyles.css";
import Modal from "../UI/modal/Modal";

const styles = {
  link: {
    color: "blue",
    textDecoration: "underline",
  },
};

const Link = (props) => {
  const { contentState, entityKey } = props;
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <a href={url} style={styles.link}>
      {props.children}
    </a>
  );
};

const findLinkEntities = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

const LinkDecorator = {
  strategy: findLinkEntities,
  component: Link,
};

const inlineToolbarPlugin = createInlineToolbarPlugin();
const { InlineToolbar } = inlineToolbarPlugin;
const HANDLED = "handled";

let themeStyles = {
  input: "input-here",
  inputInvalid: "PUT YOUR INPUT INVALID CLASS HERE",
};
const linkPlugin = createLinkPlugin({
  theme: themeStyles,
  placeholder: "http://…",
});

const linkifyPlugin = createLinkifyPlugin();

const Toolbar = (props) => {
  console.log("props in toolbar", props);
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [newContent, setNewContent] = useState("");
  const [editorJson, setEditorJson] = useState("");
  const [oldState, setOldState] = useState(EditorState.createEmpty());
  const [state, setState] = useState({
    insertUrl: false,
    insertText: "",
    insertUrlText: "",
    errors: {},
  });
  const activeRefs = useRef(null);
  useEffect(() => {
    const pattern = /^(ftp|http|https):\/\/[^ "]+$/; // fragment locator

    const errors = {
      ...state.errors,
    };
    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    } else {
      errors["insertUrlText"] = "";
    }
    setState((state) => {
      return {
        ...state,
        errors,
      };
    });
  }, [state.insertUrlText]);
  useEffect(() => {
    setTimeout(() => {
      props.refs?.current.focus();
    }, 100);
  }, []);
  const onToggleLink = () => {
    const selection = editorState.getSelection();
    const link = window.prompt("Add link");

    if (!link) {
      setEditorState((state) => {
        return {
          ...state,
          editorState: RichUtils.toggleLink(editorState, selection, null),
        };
      });

      return "handled";
    }
    const content = this.state.editorState.getCurrentContent();
    const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
      url: link,
      target: "_blank",
    });
    const newEditorState = EditorState.push(
      this.state.editorState,
      contentWithEntity,
      "create-entity"
    );
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    this.setState({
      ...this.state,
      editorState: RichUtils.toggleLink(newEditorState, selection, entityKey),
    });
  };
  useEffect(() => {
    try {
      // setTimeout(() => {
      //   props?.refs?.current.focus();
      // });
      try {
        const content = convertFromHTML(props.value);

        const { contentBlocks, entityMap } = content;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );
        const editorstate = EditorState.createWithContent(contentState);
        if (props.value || editorState) {
          setEditorState(props.value ? editorstate : EditorState.createEmpty());
          setOldState(props.value ? editorstate : EditorState.createEmpty());
        }
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  }, [props.value]);

  const trimDataFromEditor = () => {
    let editorRawData = convertToRaw(editorState.getCurrentContent());
    editorRawData.blocks = editorRawData.blocks.filter((el) => el.text);
    editorRawData.blocks = editorRawData.blocks.map((el) => {
      const indexOfFirstChar = el.text.search(/\S/);
      if (indexOfFirstChar > 0) {
        el.text = el.text.slice(indexOfFirstChar, el.text.length);
        el.entityRanges[0].offset =
          el.entityRanges[0].offset - indexOfFirstChar;
      }
      return el;
    });
    return editorRawData;
  };

  const submitData = async () => {
    const content = editorState.getCurrentContent();
    const currentPlainText = content.getPlainText();
    const lengthOfTrimmedContent = currentPlainText.trim().length;
    if (
      editorState.getCurrentContent().hasText() &&
      lengthOfTrimmedContent > 0
    ) {
      if (oldState.getCurrentContent() !== editorState.getCurrentContent()) {
        const datatrim = trimDataFromEditor(editorState);
        let newdata = EditorState.createWithContent(convertFromRaw(datatrim));
        props.getRawData(props.name, stateToHTML(newdata.getCurrentContent()));

        props?.onError("");
      }
      props?.onBlurClose();
    } else if (props.description?.is_required == false) {
      props.getRawData(
        props.name,
        stateToHTML(editorState.getCurrentContent())
      );
      props?.onBlurClose();
    } else {
      try {
        props?.onError("Field is required");
      } catch (error) {
        console.log(error);
      }
    }
  };

  const onUrlInsert = () => {
    setState((state) => {
      return {
        ...state,
        insertUrl: true,
      };
    });
    props.linkifyClick();
  };

  const onHideText = () => {
    setState((state) => {
      return {
        ...state,
        insertUrl: false,
        insertText: "",
        insertUrlText: "",
      };
    });
    props.disabledLinkify();
  };

  const insertUrlLink = () => {
    if (validate()) {
      setState((state) => {
        return {
          ...state,
          insertUrl: false,
        };
      });
      const url = state.insertUrlText;
      const contentState = editorState.getCurrentContent();
      const selection = editorState.getSelection();
      const entityKey = contentState
        .createEntity("LINK", "MUTABLE", { url, target: "_blank" })
        .getLastCreatedEntityKey();
      const block = contentState.getBlockForKey(selection.getStartKey());
      const start = selection.getStartOffset();
      const end = selection.getEndOffset();
      const blockText = block.getText().slice(start, end);

      const contentWithLink = Modifier.replaceText(
        contentState,
        selection,
        blockText || state.insertText,
        null,
        entityKey
      );

      const newEditorState = EditorState.push(
        editorState,
        contentWithLink,
        "insert-characters"
      );

      const ddeTe = EditorState.forceSelection(
        newEditorState,
        contentWithLink.getSelectionAfter()
      );

      setEditorState(ddeTe);
      setState({
        ...state,
        insertText: "",
        insertUrlText: "",
        errors: {},
        insertUrl: false,
      });
    }
    props.disabledLinkify();
  };

  const insertLinkHandler = (event) => {
    setState((state) => {
      return { ...state, [event.target.name]: event.target.value };
    });
    validate(event);
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const pastedValue = event.clipboardData.getData("text");
    setState((state) => {
      return {
        ...state,
        [event.target.name]: pastedValue,
      };
    });
    validate(event);
  };
  // useEffect(() => {
  //   setState((state) => {
  //     return {
  //       ...state,
  //       attachImages: props.uploadAtt,
  //     };
  //   });
  // }, [props.uploadAtt]);
  const addHttp = (url) => {
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "http://" + url;
    }
    return url;
  };
  const validate = (evt) => {
    let errors = {};

    if (!state.insertText.trim()) {
      errors["insertText"] = "Please enter URL text";
    } else {
      errors["insertText"] = "";
    }

    if (!state.insertUrlText.trim()) {
      //url validation
      errors["insertUrlText"] = "Please enter URL";
    } else {
      errors["insertUrlText"] = "";
    }
    const pattern = new RegExp(
      "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+@/]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+@=/-]*)?" + // query string
      "(\\#[-a-z\\d%_.~+@=&/?]*)?$",
      "i"
    ); // fragment locator

    if (state.insertUrlText && !pattern.test(state.insertUrlText)) {
      errors["insertUrlText"] = "Please enter valid URL";
    }

    if (errors.insertText || errors.insertUrlText) {
      setState((state) => {
        return {
          ...state,
          errors: { ...state.errors, ...errors },
        };
      });
      return false;
    }
    setState((state) => {
      return {
        ...state,
        errors: { ...state.errors, ...errors },
      };
    });

    return true;
  };

  const onChange = async (editorState) => {
    try {
      const currentContent = editorState.getCurrentContent();
      const newContent = editorState.getCurrentContent();

      if (currentContent !== newContent) {
        setNewContent(currentContent);
      } else {
        setNewContent(newContent);
      }
      const editorJSON = JSON.stringify(
        convertToRaw(editorState.getCurrentContent())
      );
      setEditorState(editorState);
      setEditorJson(editorJSON);

      if (currentContent !== newContent) {
        let html = stateToHTML(editorState.getCurrentContent());
        props.getRawData(html);
      }
      let urlText = "";
      const currentSelection = editorState.getSelection();
      if (currentSelection.isCollapsed()) {
        setState((state) => {
          return {
            ...state,
            selectedText: "",
            insertText: "",
            insertUrlText: "",
          };
        });
        return;
      }
      const startOffset = currentSelection.getStartOffset();
      const endOffset = currentSelection.getEndOffset();
      const isBackward = currentSelection.getIsBackward();

      let selectedText;
      if (isBackward) {
        selectedText = editorState
          .getCurrentContent()
          .getBlockForKey(currentSelection.getStartKey())
          .getText()
          .slice(
            currentSelection.getFocusOffset(),
            currentSelection.getAnchorOffset()
          );
        setState((state) => {
          return {
            ...state,
            errors: {},
          };
        });
      } else {
        selectedText = editorState
          .getCurrentContent()
          .getBlockForKey(currentSelection.getStartKey())
          .getText()
          .slice(
            currentSelection.getAnchorOffset(),
            currentSelection.getFocusOffset()
          );
        setState((state) => {
          return {
            ...state,
            errors: {},
          };
        });
      }
      const start = currentSelection.getStartOffset();
      const end = currentSelection.getEndOffset();
      const contentState = editorState.getCurrentContent();
      const block = contentState.getBlockForKey(currentSelection.getStartKey());
      const entityKey = block.getEntityAt(start);
      if (entityKey) {
        const entity = contentState.getEntity(entityKey);
        if (entity.getType() === "LINK") {
          const url = entity.getData().url;
          urlText = url;
        }
      }

      setState((state) => {
        return {
          ...state,
          selectedText: selectedText,
          insertText: selectedText,
          insertUrlText: urlText || state.insertUrlText,
        };
      });
      // else {
      //   return false;
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const handleFocus = () => {
    setEditorState(EditorState.moveFocusToEnd(editorState));
  };

  return (
    <>
      <Modal show={state.insertUrl} close={onHideText}>
        <div className="form-group">
          {!state.selectedText && (
            <>
              <label className="m-0">Text</label>
              <input
                type="text"
                className="form-control"
                onChange={insertLinkHandler}
                value={state.insertText}
                name="insertText"
                placeholder="Link text"
              />
            </>
          )}
          <div className="error">
            {state.errors?.["insertText"] && state.errors?.["insertText"]}
          </div>
        </div>
        <div className="form-group">
          <label>URL</label>
          <input
            type="text"
            className="form-control"
            onChange={insertLinkHandler}
            name="insertUrlText"
            value={state.insertUrlText}
            placeholder="http://"
            onPaste={handlePaste}
          />
          <div className="error">
            {state.errors?.["insertUrlText"] && state.errors?.["insertUrlText"]}
          </div>
        </div>
        <button
          className="muBtn _blue mt-3 float-end"
          type="button"
          onClick={insertUrlLink}
        >
          OK
        </button>
      </Modal>{" "}
      <div
        className="allTools"
        tabIndex={100}
      // onBlur={(e) => {
      //   const currentTarget = e.currentTarget;
      //   requestAnimationFrame(() => {
      //     if (!currentTarget.contains(document.activeElement)) {
      //       submitData();
      //     }
      //   });
      // }}
      >
        <div className="editor">
          <div>
            <Editor
              editorState={editorState}
              onChange={onChange}
              onFocus={() => {
                setTimeout(() => {
                  handleFocus();
                }, 10);
              }}
              plugins={[
                linkifyPlugin,
                toolbarPlugin,
                inlineToolbarPlugin,
                linkPlugin,
              ]}
              ref={props.refs}
            />
          </div>
        </div>
        <StaticToolbar fileFalse={props.fileFalse} toggleLink={onUrlInsert} />
        {props.min_length &&
          editorState.getCurrentContent().getPlainText().trim().length < props.min_length &&
          editorState.getCurrentContent().getPlainText().trim().length > 0 && (
            <span className="description-warning">
              <i className="fas fa-exclamation-triangle"></i>
              The recommended {props.name.toLowerCase()} length is at least {props.min_length} characters.
            </span>
          )}

        {/* <InlineToolbar>
          {(externalProps) => (
            <div>
              <linkPlugin.LinkButton {...externalProps} />
            </div>
          )}
        </InlineToolbar> */}
        <div className="d-flex gap-3 ms-auto">
          <button
            className="cancl-cls"
            style={{ width: "fit-content", height: "33px" }}
            text="Cancel"
            onClick={() => {
              props.onBlurClose();
            }
            }
          >
            Cancel
          </button>
          <button
            type="button"
            className="muBtn _blue ms-auto"
            style={{ width: "fit-content", height: "33px" }}
            data-bs-dismiss="modal"
            disabled={state.isLoading}
            onClick={() => {
              submitData();
              props.onBlurClose();
            }}
          >
            Save Description
          </button>


        </div>


      </div>
    </>
  );
};

export default Toolbar;
